var _rect, _path, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCameraCaptureIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 56,
    height: 56,
    rx: 28,
    fill: "#D1E9FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.1667 27.1667L32.8652 24.5637C32.4907 23.8146 32.3034 23.44 32.024 23.1664C31.7769 22.9244 31.4791 22.7403 31.1521 22.6275C30.7824 22.5 30.3636 22.5 29.526 22.5H25.0667C23.7599 22.5 23.1065 22.5 22.6074 22.7543C22.1684 22.978 21.8114 23.335 21.5877 23.774C21.3334 24.2731 21.3334 24.9265 21.3334 26.2333V27.1667M21.3334 27.1667H39.0667C41.0269 27.1667 42.007 27.1667 42.7557 27.5481C43.4142 27.8837 43.9497 28.4191 44.2852 29.0777C44.6667 29.8264 44.6667 30.8065 44.6667 32.7667V37.9C44.6667 39.8602 44.6667 40.8403 44.2852 41.589C43.9497 42.2475 43.4142 42.783 42.7557 43.1185C42.007 43.5 41.0269 43.5 39.0667 43.5H26.9334C24.9732 43.5 23.9931 43.5 23.2444 43.1185C22.5858 42.783 22.0504 42.2475 21.7149 41.589C21.3334 40.8403 21.3334 39.8602 21.3334 37.9V27.1667ZM37.0834 39.4167L35.3334 37.6667M36.5 34.75C36.5 37.0052 34.6719 38.8333 32.4167 38.8333C30.1615 38.8333 28.3334 37.0052 28.3334 34.75C28.3334 32.4948 30.1615 30.6667 32.4167 30.6667C34.6719 30.6667 36.5 32.4948 36.5 34.75Z",
    stroke: "#1570EF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 56,
    height: 56,
    rx: 28,
    stroke: "#EFF8FF",
    strokeWidth: 10
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraCaptureIcon);
export default __webpack_public_path__ + "static/media/CameraCaptureIcon.f39dc5de35877bd035a93276944013e0.svg";
export { ForwardRef as ReactComponent };